import React, { useCallback, useState } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
  Annotation,
} from "react-simple-maps";
import * as d3Geo from "d3-geo";
import "tailwindcss/tailwind.css";
import { data } from "../../datas/data-brazil-map";

const geoUrl =
  "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson";

const BrazilMapChart = () => {
  const [hoveredRegion, setHoveredRegion] = useState({
    sigla: null,
    state: null,
    ECH: null,
    HE: null,
    SE: null,
    GE: null,
    FE: null,
    coordinates: null,
  });
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const regionColors = {
    Norte: "#1f9d55",
    Nordeste: "#1f9d55",
    "Centro-Oeste": "#1f9d55",
    Sudeste: "#1f9d55",
    Sul: "#1f9d55",
  };

  const getRegion = (state) => {
    const regions = {
      Norte: ["AC", "AP", "AM", "PA", "RO", "RR", "TO"],
      Nordeste: ["AL", "BA", "CE", "MA", "PB", "PE", "PI", "RN", "SE"],
      "Centro-Oeste": ["DF", "GO", "MT", "MS"],
      Sudeste: ["ES", "MG", "RJ", "SP"],
      Sul: ["PR", "RS", "SC"],
    };
    return (
      Object.keys(regions).find((region) => regions[region].includes(state)) ||
      "#ccc"
    );
  };

  return (
    <>
      <h2 className="w-full text-xl text-center font-bold mb-4">
        Distribuição de Estados por Região
      </h2>
      <div className="w-full relative cursor-default">
        <ComposableMap
          projection="geoMercator"
          projectionConfig={{
            scale: 700, // Aumenta o zoom do mapa
            center: [-52, -15], // Centraliza o Brasil corretamente
          }}
        >
          <Geographies geography={geoUrl}>
            {({ geographies }) =>
              geographies.map((geo) => {
                const stateCode = geo.properties.sigla || geo.properties.UF; // Ajuste conforme necessário

                const region = getRegion(stateCode);
                const geometry = geo.geometry;

                const [longitude, latitude] = d3Geo.geoCentroid(geometry);

                return (
                  <g
                    // onClick={() => handleStateClick(stateCode)}
                    key={geo.rsmKey}
                    onMouseEnter={() => {
                      const hoveredState = data.find(
                        (item) => item.sigla === stateCode
                      );
                      if (hoveredState) {
                        setHoveredRegion({
                          state: hoveredState.state,
                          ECH: hoveredState.ECH,
                          HE: hoveredState.HE,
                          SE: hoveredState.SE,
                          GE: hoveredState.GE,
                          FE: hoveredState.FE,
                          coordinates: d3Geo.geoCentroid(geometry),
                        });
                      }
                    }}
                    onMouseLeave={() => setHoveredRegion(null)}
                  >
                    <Geography
                      geography={geo}
                      fill={
                        stateCode === "AP" ? "#ffeb3b" : regionColors[region]
                      }
                      stroke="#FFF"
                      className="hover:opacity-75 transition relative cursor-default"
                      onMouseEnter={() => {
                        const hoveredState = data.find(
                          (item) => item.sigla === stateCode
                        );
                        if (hoveredState) {
                          setHoveredRegion({
                            state: hoveredState.state,
                            ECH: hoveredState.ECH,
                            HE: hoveredState.HE,
                            SE: hoveredState.SE,
                            GE: hoveredState.GE,
                            FE: hoveredState.FE,
                            coordinates: d3Geo.geoCentroid(geometry),
                          });
                        }
                      }}
                      onMouseMove={(e) => {
                        setTooltipPosition({ x: e.clientX, y: e.clientY });
                      }}
                      onMouseLeave={() => setHoveredRegion(null)}
                    />
                    <Annotation subject={[longitude, latitude]} dx={0} dy={0}>
                      <text
                        textAnchor="middle"
                        style={{
                          fontFamily: "Arial, sans-serif",
                          fontSize: "10px",
                          fill: "#fff",
                          fontWeight: "bold",
                        }}
                      >
                        {stateCode}
                      </text>
                    </Annotation>
                  </g>
                );
              })
            }
          </Geographies>
        </ComposableMap>

        {hoveredRegion?.state && (
          <div
            className="absolute bg-white/90 backdrop-blur-md p-4 rounded-xl shadow-xl text-sm transition-opacity duration-200 cursor-default"
            style={{
              left: `${tooltipPosition.x - 500}px`, // Ajuste fino para evitar sobreposição do cursor
              top: `${tooltipPosition.y + 15}px`,
              pointerEvents: "none", // Evita que o tooltip interfira no mouse
              transform: "translate(-50%, -50%)",
              minWidth: "180px", // Largura mínima para evitar quebras
            }}
          >
            <h3 className="font-bold text-gray-900 cursor-default">
              {hoveredRegion.state}
            </h3>
            <hr className="my-2 border-gray-300 cursor-default" />
            {Object.entries({
              "📘 Ciências Humanas": hoveredRegion.ECH,
              "📖 Filosofia": hoveredRegion.FE,
              "🗺 Geografia": hoveredRegion.GE,
              "📜 História": hoveredRegion.HE,
              "🧑‍🤝‍🧑 Sociologia": hoveredRegion.SE,
            })
              .sort((a, b) => b[1] - a[1])
              .map(([key, value]) => (
                <p key={key} className="text-gray-700 cursor-default">
                  <strong>{key}:</strong> {value}%
                </p>
              ))}
          </div>
        )}
      </div>
    </>
  );
};

export default BrazilMapChart;
